/** @jsxImportSource @emotion/react */
import React from 'react';
import { Alert, Space, Tag } from 'antd';
import { DISEASE_NAMES, PEST_CODES } from '../constants';

interface DiseaseState {
  code: string;
  severity: number;
  active?: boolean;
}

interface Props {
  forecastSeries: any;
}

const DiseaseAlert: React.FC<Props> = ({ forecastSeries }) => {
  const activeDiseases: DiseaseState[] = ((forecastSeries?.finalState as any)?.diseaseStates || [])
    .filter((d: DiseaseState) => d.active);

  if (activeDiseases.length === 0) return null;

  const maxSev = Math.max(...activeDiseases.map((d) => d.severity));
  const alertType = maxSev > 0.5 ? 'error' : maxSev > 0.2 ? 'warning' : 'info';

  return (
    <Alert
      type={alertType as any}
      showIcon
      message={
        <Space wrap>
          {activeDiseases.map((d) => {
            const isPest = PEST_CODES.has(d.code);
            const icon = isPest ? '🐛' : '☣️';
            const sevPct = Math.round(d.severity * 100);
            const color = sevPct > 50 ? 'red' : sevPct > 20 ? 'orange' : 'gold';
            return (
              <Tag key={d.code} color={color}>
                {icon} {DISEASE_NAMES[d.code] || d.code} {sevPct}%
              </Tag>
            );
          })}
        </Space>
      }
    />
  );
};

export default DiseaseAlert;
